import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum ReportCommonReduxTypes {
  REPORT = "@@auth/REPORT",
  LIST_REPORT = "@@auth/LIST_REPORT",
  LIST_REPORT_SUCCESS = "@@auth/LIST_REPORT_SUCCESS",
  LIST_REPORT_ERROR = "@@auth/LIST_REPORT_ERROR",

  DOWNLOAD_REPORT = "@@auth/DOWNLOAD_REPORT",
  DOWNLOAD_REPORT_SUCCESS = "@@auth/DOWNLOAD_REPORT_SUCCESS",
  DOWNLOAD_REPORT_ERROR = "@@auth/DOWNLOAD_REPORT_ERROR",

  RESET = "@@auth/RESET"
}
export type ListReports = {
  reportName: string;
  createdOn: string;
  generatedBy: string;
  batchFilePath: string;
  filterMetaData: FilterMetadata;
};

export type ReportListActionDispatch = {
  type: 
  |ReportCommonReduxTypes.LIST_REPORT  
  | ReportCommonReduxTypes.DOWNLOAD_REPORT
  | ReportCommonReduxTypes.RESET;
  payload: any;
};

export type ReportActionDispatch = {
  type: ReportCommonReduxTypes.REPORT;
  payload: any;
};
export type ReportReducerDispatch = {
  type: 
  ReportCommonReduxTypes.LIST_REPORT 
  | ReportCommonReduxTypes.LIST_REPORT_SUCCESS 
  | ReportCommonReduxTypes.LIST_REPORT_ERROR
  | ReportCommonReduxTypes.DOWNLOAD_REPORT
  | ReportCommonReduxTypes.DOWNLOAD_REPORT_SUCCESS
  | ReportCommonReduxTypes.DOWNLOAD_REPORT_ERROR
  | ReportCommonReduxTypes.RESET;
  payload: {
    data?: FetchApiResponse<ReportList> | Blob;
    error?: string;
  };
};

// export type CreateDisbursementAdvice = {
//   startDate: string;
//   endDate: string;
//   programId: string;
//   counterPartyId: string;
//   anchorId: string;
//   saveReport: boolean;
// };
export type CreateReportListRequest = {
  payload: ReportList;
  type: string;
};

export type ReportList = {
  id: string;
  financierId: string;
  userId: string;
  type: string;
  status: number;
  updatedOn: string;
  createdOn: string;
};

export type ListReport = {
  reportName: string;
  createdOn: string;
  createdBy: string;
  userId: string;
  filterMetaData: FilterMetadata;
};

export type CreateReportReduxState = {
  loading?: boolean;
  data?: CreateApiResponse<ReportList>;
  error?: string | null;
};
export type ReportReduxState = {
  loading?: boolean;
  data?: CreateApiResponse<ReportList>;
  error?: string | null;
};

export type DownloadReport = {
  payload: {
    location: string;
  },
  type: string
}
export type DownloadReportReduxState = {
  loading?: boolean;
  data?: Blob | null ;
  error?: string | null;
}